/* ShySproutStudios runtime: cart, overlays, toast. Vanilla, no dependencies. */
(function () {
  'use strict';

  var SS = (window.SS = window.SS || {});
  var config = document.getElementById('ss-config');
  SS.settings = config ? JSON.parse(config.textContent) : {};

  /* ---------- money ---------- */
  SS.money = function (cents) {
    var format = SS.settings.moneyFormat || '${{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var noDecimals = key.indexOf('no_decimals') !== -1;
    var sep =
      key.indexOf('comma_separator') !== -1
        ? ['.', ',']
        : key.indexOf('space_separator') !== -1
          ? [' ', ',']
          : key.indexOf('apostrophe_separator') !== -1
            ? ["'", '.']
            : [',', '.'];
    var parts = (cents / 100).toFixed(noDecimals ? 0 : 2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep[0]);
    var value = parts[1] ? parts[0] + sep[1] + parts[1] : parts[0];
    return m ? format.replace(m[0], value) : value;
  };

  /* ---------- toast + screen reader announcer ---------- */
  /* Both live regions are created eagerly (script is deferred, body exists) so
     they are present in the accessibility tree before the first announcement:
     a live region inserted at announce time does not announce its initial content. */
  var toastEl = document.createElement('div');
  toastEl.className = 'ss-toast';
  toastEl.setAttribute('role', 'status');
  toastEl.setAttribute('aria-live', 'polite');
  document.body.appendChild(toastEl);

  var announcer = document.createElement('div');
  announcer.className = 'visually-hidden';
  announcer.setAttribute('role', 'status');
  announcer.setAttribute('aria-live', 'polite');
  document.body.appendChild(announcer);

  var toastTimer = null;
  SS.toast = function (message) {
    clearTimeout(toastTimer);
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2600);
  };

  SS.announce = function (message) {
    /* Clear first so repeating the same message is still announced. */
    announcer.textContent = '';
    window.setTimeout(function () {
      announcer.textContent = message;
    }, 50);
  };

  /* ---------- overlays ---------- */
  var openOverlays = [];
  var lastFocus = {};
  var FOCUSABLE_SELECTOR =
    'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function overlayFocusables(el) {
    return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE_SELECTOR), function (node) {
      return !node.disabled && node.getAttribute('aria-hidden') !== 'true' && node.getClientRects().length > 0;
    });
  }

  SS.overlay = {
    open: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      lastFocus[id] = document.activeElement;
      el.classList.add('is-open');
      el.removeAttribute('inert');
      document.body.classList.add('ss-scroll-locked');
      if (openOverlays.indexOf(id) === -1) openOverlays.push(id);
      var focusable = el.querySelector('[data-ss-autofocus], button, a, input, [tabindex]');
      if (focusable) focusable.focus({ preventScroll: true });
      el.dispatchEvent(new CustomEvent('ss:overlay:open', { bubbles: true }));
    },
    close: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('inert', '');
      openOverlays = openOverlays.filter(function (x) {
        return x !== id;
      });
      if (!openOverlays.length) document.body.classList.remove('ss-scroll-locked');
      var trigger = lastFocus[id];
      delete lastFocus[id];
      if (trigger && trigger.isConnected && typeof trigger.focus === 'function') {
        trigger.focus({ preventScroll: true });
      }
      el.dispatchEvent(new CustomEvent('ss:overlay:close', { bubbles: true }));
    },
    closeAll: function () {
      openOverlays.slice().forEach(SS.overlay.close);
    }
  };

  document.addEventListener('keydown', function (e) {
    if (!openOverlays.length) return;
    if (e.key === 'Escape') {
      SS.overlay.close(openOverlays[openOverlays.length - 1]);
      return;
    }
    if (e.key !== 'Tab') return;
    /* Focus trap: keep Tab cycling inside the topmost open overlay. */
    var el = document.getElementById(openOverlays[openOverlays.length - 1]);
    if (!el) return;
    var focusables = overlayFocusables(el);
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var active = document.activeElement;
    if (!el.contains(active)) {
      e.preventDefault();
      first.focus({ preventScroll: true });
    } else if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus({ preventScroll: true });
    }
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ss-overlay-open]');
    if (opener) {
      e.preventDefault();
      SS.overlay.open(opener.getAttribute('data-ss-overlay-open'));
      return;
    }
    var closer = e.target.closest('[data-ss-overlay-close]');
    if (closer) {
      e.preventDefault();
      var overlay = closer.closest('[data-ss-overlay]');
      if (overlay) SS.overlay.close(overlay.id);
    }
  });

  /* ---------- cart ---------- */
  var CART_SECTIONS = ['cart-drawer'];

  function cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : value.replace(/["\\]/g, '\\$&');
  }

  function refreshSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var target = document.querySelector('[data-ss-cart-section="' + key + '"]');
      if (!target || !sections[key]) return;
      var doc = new DOMParser().parseFromString(sections[key], 'text/html');
      var replacement = doc.querySelector('[data-ss-cart-section="' + key + '"]');
      if (!replacement) return;
      /* Capture focus context BEFORE the swap: afterwards activeElement is <body>. */
      var active = document.activeElement;
      var hadFocus = active && target.contains(active);
      var label = hadFocus ? active.getAttribute('aria-label') : null;
      var line = hadFocus ? Number(active.getAttribute('data-line')) : null;
      target.replaceWith(replacement);
      if (!hadFocus) return;
      var next = null;
      if (label) {
        var esc = cssEscape(label);
        if (line) {
          /* Same control on the same line, e.g. the "+" the user just pressed. */
          next = replacement.querySelector(
            '[data-ss-qty-change][data-line="' + line + '"][aria-label="' + esc + '"]'
          );
        }
        if (!next) {
          /* Line removed or renumbered: equivalent control on min(line, lastLine). */
          var same = replacement.querySelectorAll('[data-ss-qty-change][aria-label="' + esc + '"]');
          if (same.length) next = same[Math.min(line || 1, same.length) - 1];
        }
        if (!next) {
          next = replacement.querySelector('[aria-label="' + esc + '"]');
        }
      }
      if (!next) {
        /* Cart emptied or non-line control: close button / start-shopping link. */
        next = replacement.querySelector('[data-ss-autofocus], button, a, input, [tabindex]');
      }
      if (next) next.focus({ preventScroll: true });
    });
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.toggleAttribute('data-empty', cart.item_count === 0);
    });
  }

  function afterCartChange(cart, sections) {
    updateCartCount(cart);
    refreshSections(sections);
    document.dispatchEvent(
      new CustomEvent('ss:cart:updated', { detail: { cart: cart, sections: sections } })
    );
  }

  function cartRequest(url, payload) {
    payload.sections = CART_SECTIONS.join(',');
    payload.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  SS.cart = {
    get: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });
    },
    add: function (items) {
      return cartRequest('/cart/add.js', { items: Array.isArray(items) ? items : [items] }).then(
        function (data) {
          return SS.cart.get().then(function (cart) {
            afterCartChange(cart, data.sections);
            return data;
          });
        }
      );
    },
    change: function (payload) {
      return cartRequest('/cart/change.js', payload).then(function (cart) {
        afterCartChange(cart, cart.sections);
        /* The drawer live region is replaced wholesale by refreshSections, so a
           freshly inserted region never announces; use the persistent announcer. */
        SS.announce(
          'Basket updated · ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items')
        );
        return cart;
      });
    }
  };

  /* ---------- add-to-cart form interception ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ss-atc]');
    if (!form) return;
    e.preventDefault();
    /* Prefer the actual submitter: the sticky-bar button lives outside the form
       (submits via the form attribute) and would otherwise get no feedback. */
    var button = e.submitter || form.querySelector('[type="submit"]');
    if (button && button.getAttribute('aria-disabled') === 'true') return;
    var formData = new FormData(form);
    var item = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) };
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) item.properties = properties;

    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
    }

    SS.cart
      .add(item)
      .then(function () {
        var title = form.getAttribute('data-ss-product-title');
        var added =
          form.getAttribute('data-ss-toast-added') ||
          document.body.getAttribute('data-ss-toast-added') ||
          'added to your basket 🌱';
        SS.toast(title ? title + ' ' + added : 'Added to your basket 🌱');
        if (document.body.dataset.cartType === 'drawer' && document.getElementById('cart-drawer')) {
          SS.overlay.open('cart-drawer');
        }
      })
      .catch(function (err) {
        SS.toast((err && err.description) || 'Could not add that just now, sorry!');
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('is-loading');
        }
      });
  });

  /* ---------- cart line quantity / remove (drawer + cart page) ---------- */
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-ss-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      var line = Number(qtyBtn.getAttribute('data-line'));
      var qty = Number(qtyBtn.getAttribute('data-quantity'));
      qtyBtn.setAttribute('aria-disabled', 'true');
      SS.cart.change({ line: line, quantity: qty }).catch(function (err) {
        SS.toast((err && err.description) || 'Could not update your basket.');
      });
    }
  });

  /* ---------- live Instagram follower count ---------- */
  /* Progressive enhancement: the server renders the metafield/setting value,
     then the live number from the configured endpoint replaces it on idle.
     Cached in sessionStorage for an hour so browsing does not re-fetch. */
  (function () {
    var url = SS.settings.followerUrl;
    if (!url) return;
    var spans = document.querySelectorAll('[data-ss-ig-count]');
    if (!spans.length) return;

    function apply(value) {
      spans.forEach(function (el) {
        el.textContent = value;
      });
    }

    function formatCount(n) {
      if (n < 1000) return String(n);
      var k = n / 1000;
      var rounded = k >= 100 ? Math.round(k) : Math.round(k * 10) / 10;
      return (rounded + 'k').replace('.0k', 'k');
    }

    var CACHE_KEY = 'ss-ig-count';
    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && cached.v && Date.now() - cached.t < 3600000) {
        apply(cached.v);
        return;
      }
    } catch (err) {
      /* storage unavailable: fetch fresh */
    }

    function run() {
      var controller = 'AbortController' in window ? new AbortController() : null;
      var timer = controller
        ? setTimeout(function () {
            controller.abort();
          }, 6000)
        : null;
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (timer) clearTimeout(timer);
          var value = null;
          if (data && data.formatted) {
            value = String(data.formatted).toLowerCase();
          } else if (data && typeof data.followers_count === 'number') {
            value = formatCount(data.followers_count);
          } else if (data && typeof data.followersCount === 'number') {
            value = formatCount(data.followersCount);
          }
          if (!value) return;
          apply(value);
          try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify({ v: value, t: Date.now() }));
          } catch (err) {
            /* storage unavailable: fine, we already applied */
          }
        })
        .catch(function () {
          /* endpoint down: the server-rendered value stays */
        });
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 4000 });
    } else {
      setTimeout(run, 1500);
    }
  })();
})();
